import { locationIdFormat } from "@redotech/redo-inventory-id";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";
import {
  inventoryRuleSchema,
  inventoryRuleSettingsLocationSchema,
} from "./inventory-rule-models";

/** The warehouse's rules at its processing level, with what the settings rows offer. */
export const listInventoryRuleSettings = unaryRpc({
  name: "listInventoryRuleSettings" as const,
  input: z.object({ locationId: locationIdFormat.schema }),
  output: inventoryRuleSettingsLocationSchema.extend({
    /** The merchant's offered grades. */
    grades: z.array(z.string()),
    rules: z.array(inventoryRuleSchema),
  }),
});

/**
 * Replaces each target's rules at the source's level with copies of the
 * source's, disabling the old ones. Also how a new location gets its rules.
 */
export const applyInventoryRuleSettings = unaryRpc({
  name: "applyInventoryRuleSettings" as const,
  input: z.object({
    fromLocationId: locationIdFormat.schema,
    toLocationIds: z.array(locationIdFormat.schema).min(1),
  }),
  output: z.object({
    locations: z.array(
      z.object({
        locationId: locationIdFormat.schema,
        copiedRuleCount: z.int().min(0),
      }),
    ),
  }),
});
